module.exports = __webpack_public_path__ + "static/media/support.6a979053.svg";